export default __webpack_public_path__ + "static/media/Feedback-loop.c85cc29f.png";